// src/locales/en/auth.js
export const auth = {
    // Login/Signup Form Fields
    name: "Full Name",
    email: "Email Address", 
    password: "Password",
    confirmPassword: "Confirm Password",
    
    // Form validation
    nameRequired: "Name is required",
    emailRequired: "Email is required",
    passwordRequired: "Password is required", 
    passwordMinLength: "Password must be at least 6 characters",
    passwordsDoNotMatch: "Passwords do not match",
    invalidCredentials: "Invalid email or password",
    loginToConnect: "Please login to continue.",
    validEmailRequired: "Please enter a valid email",
    
    // Login page
    welcomeBack: "Welcome Back",
    signInToDashboard: "Sign in to your dashboard",
    signIn: "Sign In",
    rememberMe: "Remember me",
    forgotPassword: "Forgot password?",
    dontHaveAccount: "Don't have an account?",
    
    // Signup page
    createAccount: "Create Account",
    startManaging: "Start managing your business today",
    signup: "Sign Up",
    login: "Login",
    logout: "Logout",
    alreadyHaveAccount: "Already have an account?",
    
    // Success messages
    loginSuccessful: "Login Successful",
    signupSuccessful: "Account Created",
    accountCreated: "Account created successfully! Please check your email to verify your account.",
    accountCreatedAndLoggedIn: "Welcome {{name}}! Your account has been created and you're now logged in. Please verify your email to complete setup.",
    
    // Social auth
    continueWithGoogle: "Continue with Google",
    
    // Common
    or: "or"
}